export type PrometheusPostgreSqlUpdateStatsBackendApiProps = {
    created: number;
    instance: string;
    pg_stat_database_tup_updated: number;
};

export default class PrometheusPostgreSqlUpdateStats {
    readonly created: number;
    readonly instance: string;
    readonly pgStatDatabaseTupUpdated: number;

    constructor(props: PrometheusPostgreSqlUpdateStatsBackendApiProps) {
        this.created = props.created;
        this.instance = props.instance;
        this.pgStatDatabaseTupUpdated = props.pg_stat_database_tup_updated;
    }
}
